module.exports = __webpack_public_path__ + "static/media/deliveriesBackground.7b2f8138.jpg";